//检验方式
export const inMethods = (e: number) => {
    switch (e) {
        case 0:
            return '免检'
        case 1:
            return '抽检(减量)'
        case 2:
            return '抽检(正常)'
        case 3:
            return '抽检(加严)'
        case 4:
            return '全检'
    }
}
export const Result = (scope: number)=>{    
  switch (scope) {
        case 0:
            return "N/A"
        case 1:
            return "合格"
        case 2:
            return "返修"
        case 3:
            return "报废"
        case 4:
            return "技术确认"
        case 5:
            return "让步接收"
        case 6:
            return "退货"
        case 7:
            return "免检"
  }
  
}
export const ResultNumber = (scope: any)=>{
    if(scope.inspectionMethod==0){
        return scope.collectQuantity
    }else if(scope.isQuality==1){
        switch (scope.qualityResult) {
            case 0:
                return scope.collectQuantity-scope.qualityNumber
            case 1:
                return scope.collectQuantity
            case 2:
                return scope.collectQuantity-scope.qualityNumber
            case 3:
                return scope.collectQuantity-scope.qualityNumber
            case 4:
                return scope.collectQuantity-scope.qualityNumber
            case 5:
                return scope.collectQuantity
            case 6:
                return scope.collectQuantity-scope.qualityNumber
            case 7:
                return scope.collectQuantity
      }
    }else{
        return 0
    }    
  }